import { render, staticRenderFns } from "./LogecImport.vue?vue&type=template&id=4b6b31fe"
import script from "./LogecImport.vue?vue&type=script&lang=js"
export * from "./LogecImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports